module.exports = __webpack_public_path__ + "img/sample-report-12@3x.1a3ecf00.png";